<template>
    <div>
      <div class="db-filter-modal">
        <div class="db-filter-title-text">Filter Tujuan Pendaftaran</div>
        <div class="db-filter-edit-form">
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Nomor</div>
            <div class="db-filter-hiw-full">
              <input
                type="number"
                class="db-filter-hiw-text"
              />
            </div>
          </div>
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Deskripsi</div>
            <div class="db-filter-hiw-full">
              <input
                type="text"
                class="db-filter-hiw-text"
              />
            </div>
          </div>
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Landing Page</div>
            <div class="db-filter-hiw-multiple">
              <select class="db-filter-hiw-select-full">
                <option>Yes</option>
                <option>No</option>
              </select>
            </div>
          </div>   
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Registrasi Ke Ariba</div>
            <div class="db-filter-hiw-multiple">
              <select class="db-filter-hiw-select-full">
                <option>No Editable (Check)</option>
                <option>No Editable (Uncheck)</option>
                <option>No Editable All (Check)</option>
                <option>No Editable</option>
                <option>Editable (Check)</option>
                <option>Editable (Uncheck)</option>
              </select>
            </div>
          </div>   
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Last Modified Date</div>
            <div class="db-filter-hiw-date">
              <input
                type="date" class="hd-2-row"
              />
              <input
                type="date" class="hd-2-row"
              />
            </div>
          </div>
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Last Modified By</div>
            <div class="db-filter-hiw-full">
              <input
                type="text"
                class="db-filter-hiw-text"
              />
            </div>
          </div> 
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Catatan</div>
            <div class="db-filter-hiw-full">
              <input
                type="text"
                class="db-filter-hiw-text"
              />
            </div>
          </div>  
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Status</div>
            <div class="db-filter-hiw-multiple">
              <select class="db-filter-hiw-select">
                <option>Active</option>
                <option>Inactive</option>
              </select>
            </div>
          </div>   
        </div>
        <div class="button-container">
          <div class="button-wrapper">
            <div class="email-button" @click="closeModal">CANCEL</div>
            <div class="email-button">CONFIRM</div>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
export default{
    methods :{
        closeModal(){
            this.$emit('closeModal')
        }
    }
}
</script>